/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import {getType} from "typesafe-actions"
import update from "immutability-helper"
import {
    ErrorReportActions,
    hideErrorReport,
    showErrorReport,
} from "./errorReport.actions"
import {initialState, State} from "./errorReport.state"

export default function (
    state: State = initialState,
    action: ErrorReportActions
): State {
    switch (action.type) {
        case getType(showErrorReport): {
            return update(state, {
                isVisible: {$set: true},
                error: {$set: action.payload},
            })
        }
        case getType(hideErrorReport): {
            return update(state, {
                isVisible: {$set: false},
                error: {$set: undefined},
            })
        }
        default:
            return state
    }
}
